import { type ClientContext, ContextClient } from '~/services/contextClient';
import CalendlyClientFactory from './calendlyClient.factory';
import type {
    CalendlyClientInterface,
    CalendlyEventTypesResponse,
    CalendlyGroupMapping,
    GetEventTypesParams,
    UpdateCalendlyGroupMappingParams,
} from './calendlyClient.types';
import type { AxiosPromise } from 'axios';

class CalendlyClient extends ContextClient<CalendlyClientInterface> {
    constructor() {
        super(CalendlyClientFactory);
    }

    getEventTypes(context: ClientContext, params?: GetEventTypesParams): AxiosPromise<CalendlyEventTypesResponse> {
        const client = this.getClient(context);
        return client.getEventTypes(params);
    }

    getGroupMapping(context: ClientContext, groupId: string): AxiosPromise<CalendlyGroupMapping> {
        const client = this.getClient(context);
        return client.getGroupMapping(groupId);
    }

    updateGroupMapping(
        context: ClientContext,
        groupId: string,
        data: UpdateCalendlyGroupMappingParams
    ): AxiosPromise<CalendlyGroupMapping> {
        const client = this.getClient(context);
        return client.updateGroupMapping(groupId, data);
    }
}

export default new CalendlyClient();
